import React, { useState } from "react";
import Icon, { ICONS, IconName } from "@imminently/decisively-ui/Icon";
import { useCopyToClipboard } from "react-use";

const iconList = Object.keys(ICONS) as IconName[];

export function IconsPage() {
  const [search, setSearch] = useState("");
  const [, copyToClipboard] = useCopyToClipboard();
  const [copied, setCopied] = useState<string | null>(null);
  const filteredIcons = iconList.filter(
    (name) => name.toLowerCase().includes(search.toLowerCase()) ||
      ICONS[name].label.toLowerCase().includes(search.toLowerCase())
  );

  const handleCopy = (name: IconName) => {
    copyToClipboard(`<Icon name=\"${name}\"/>`);
    setCopied(name);
    setTimeout(() => setCopied(null), 1200);
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Icons</h2>
      <input
        type="text"
        placeholder="Search icons..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        className="mb-6 px-3 py-2 border rounded w-full max-w-md"
      />
      <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-6">
        {filteredIcons.map((name) => (
          <button
            key={name}
            className="flex flex-col items-center p-2 border rounded cursor-copy hover:bg-accent focus:outline-none focus:ring-2 focus:ring-accent relative group"
            onClick={() => handleCopy(name)}
            type="button"
            title={`Copy <Icon name=\"${name}\"/> to clipboard`}
          >
            <Icon name={name} size={32} />
            <span className="mt-2 text-xs text-center break-all">{name}</span>
            {copied === name && (
              <span className="absolute top-1 left-1 bg-accent text-accent-foreground text-xs px-2 py-1 rounded shadow">
                Copied!
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
